// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-slider/dist/css/bootstrap-slider.css
// module id = 56
// module chunks = 0